import React, { useState } from "react";
import { useVisualEngine } from "../../VisualEngineProvider";
import "./AIOrb.css";

export function AIOrb({ onSubmit, placeholder = "Ask TradeLife AI..." }) {
  const { theme } = useVisualEngine();
  const isMolten = theme.id === "molten";
  const showTOrb = theme.ai.orbStyle === "t";
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");

  const submit = () => {
    if (!value.trim()) return;
    onSubmit(value);
    setValue("");
    setOpen(false);
  };

  return (
    <div className={`tl-orb-wrapper ${open ? "open" : ""}`}>
      {!open && (
        <div
          className={`tl-orb ${isMolten ? "tl-orb-molten" : ""}`}
          onClick={() => setOpen(true)}
          data-testid="command-centre-ai-orb"
        >
          {showTOrb && <span className="tl-orb-molten-core">T</span>}
        </div>
      )}

      {open && (
        <div className="tl-orb-panel" data-testid="command-centre-ai-orb-panel">
          <input
            className="tl-orb-input"
            value={value}
            placeholder={placeholder}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && submit()}
            autoFocus
            data-testid="command-centre-ai-orb-input"
          />
          <button className="tl-orb-btn" onClick={submit} data-testid="command-centre-ai-orb-send-button">
            Send
          </button>
        </div>
      )}
    </div>
  );
}
